import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createPromise } from 'redux-promise-middleware';

export default function createStore(
  reducer,
  preloadedState,
  customMiddleware = [],
) {
  const middleware = [
    createPromise({
      promiseTypeDelimiter: '-',
      promiseTypeSuffixes: ['pending', 'success', 'error'],
    }),
    ...getDefaultMiddleware({ serializableCheck: false }),
    ...customMiddleware,
  ];

  return configureStore({
    reducer,
    middleware,
    preloadedState,
  });
}
